import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Avatar from "module-common/Avatar";
import LabelList from "./TreeLabelListAgentWithQueryMutation";
import DeleteButton from "./DeleteButtonWithMutation";

export default class Card extends Component {
  static propTypes = {
    id: PropTypes.number,
    username: PropTypes.string,
    displayName: PropTypes.string,
    displayPicture: PropTypes.string,
    labels: PropTypes.array
  };

  render() {
    const { id, username, displayName, displayPicture, labels } = this.props;
    return (
      <Wrapper>
        <LeftColumn>
          <StyledAvatar image={displayPicture} />
          <DeleteButton id={id} />
        </LeftColumn>
        <RightColumn>
          <Name>{username}</Name>
          <Username>{displayName}</Username>
          <LabelList id={id} labels={labels} />
        </RightColumn>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  width: 230px;
  min-height: 100px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.panelBorder};
  margin-right: 8px;
  margin-bottom: 8px;
`;
const LeftColumn = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 70px;
  align-items: center;
  padding: 10px;
`;
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;
const StyledAvatar = styled(Avatar)`
  margin-bottom: 10px;
`;
const Username = styled.div`
  line-height: 1.2;
  margin-bottom: 10px;
`;
const Name = styled.div`
  font-weight: bold;
  line-height: 1.2;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/team-panel/Card.js